var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditorAddGradableBranch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1181_1858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 15.5C18.2165 15.5 19 14.7165 19 13.75C19 12.7835 18.2165 12 17.25 12C16.2835 12 15.5 12.7835 15.5 13.75C15.5 14.7165 16.2835 15.5 17.25 15.5Z",
    stroke: "#98BDBD",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 8.5C11.2165 8.5 12 7.7165 12 6.75C12 5.7835 11.2165 5 10.25 5C9.2835 5 8.5 5.7835 8.5 6.75C8.5 7.7165 9.2835 8.5 10.25 8.5Z",
    stroke: "#98BDBD",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 8.5C10.25 9.89239 10.8031 11.2277 11.7877 12.2123C12.7723 13.1969 14.1076 13.75 15.5 13.75",
    stroke: "#98BDBD",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 15.5C2.2835 15.5 1.5 14.7165 1.5 13.75C1.5 12.7835 2.2835 12 3.25 12C4.2165 12 5 12.7835 5 13.75C5 14.7165 4.2165 15.5 3.25 15.5Z",
    stroke: "#98BDBD",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 8.5C10.25 9.89239 9.69688 11.2277 8.71231 12.2123C7.72774 13.1969 6.39239 13.75 5 13.75",
    stroke: "#98BDBD",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66724 2.06201L0.611209 5.11804",
    stroke: "#98BDBD",
    strokeWidth: 1.16129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.611209 2.06201L3.66724 5.11804",
    stroke: "#98BDBD",
    strokeWidth: 1.16129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.669 3.89567L15.8914 5.11808L18.4211 2.0791",
    stroke: "#98BDBD",
    strokeWidth: 1.16129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1181_1858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20 0.5) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorAddGradableBranch);
export default __webpack_public_path__ + "static/media/editor_add_gradable_branch.cd762fbc7d028a7fd43942b49e23ce97.svg";
export { ForwardRef as ReactComponent };